// ==================== CONFIG ====================
const CONFIG = {
    location: {
        lat: 46.003677,
        lng: 8.951052,
        timezone: "Europe/Zurich",
    },
    api: {
        method: 99,
        methodSettings: "18,null,90 min",
        //tune= LMTVars.times_adjustments, //"0,1,2,8,2,-1,0,-1,0" The order is Imsak,Fajr,Sunrise,Dhuhr,Asr,Maghrib,Sunset,Isha,Midnight.
        tune: `${LMTVars.imsak_adj},${LMTVars.fair_adj},${LMTVars.sunrise_adj},${LMTVars.dhuhr_adj},${LMTVars.asr_adj},${LMTVars.maghrib_adj},0,${LMTVars.isha_adj},0`,
        calendarMethod: "UAQ",
        adjustment: LMTVars.hijri_adjust,
    },
    i18n: { tomorrow: "Domani" },
    prayers: [
        { key: "Fajr", label: LMTVars.fajr_title },
        { key: "Sunrise", label: LMTVars.shuruq_title },
        { key: "Dhuhr", label: LMTVars.dhuhr_title },
        { key: "Asr", label: LMTVars.asr_title },
        { key: "Maghrib", label: LMTVars.maghrib_title },
        { key: "Isha", label: LMTVars.isha_title },
    ],
};

const CALENDAR_STATE = { NORMAL: "NORMAL", RAMADAN: "RAMADAN" };
let calendarState = CALENDAR_STATE.NORMAL;

const FAKE_TODAY_ISO = "";
// const FAKE_TODAY_ISO = "2026-02-20";
// Example: "2026-02-18" (known 1 Ramadan in many calendars)

/* ==================== helpers ==================== */
// Формируем параметры API-запроса один раз
const apiParams =
    "?" +
    new URLSearchParams({
        latitude: CONFIG.location.lat,
        longitude: CONFIG.location.lng,
        method: CONFIG.api.method,
        methodSettings: CONFIG.api.methodSettings,
        tune: CONFIG.api.tune,
        timezonestring: CONFIG.location.timezone,
        calendarMethod: CONFIG.api.calendarMethod,
        adjustment: CONFIG.api.adjustment,
    });

// Форматировать дату в ISO "YYYY-MM-DD"
const formatDateISO = (date) => date.toISOString().split("T")[0];

// Парсить дату вида "DD-MM-YYYY" в Date
const parseGregorian = (d) => {
    const [day, month, year] = d.split("-").map(Number);
    return new Date(year, month - 1, day);
};

// Форматировать дату в "DD.MM.YYYY"
const formatGregorianDate = (g) => {
    const dateObj = parseGregorian(g);
    return dateObj
        .toLocaleDateString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .replace(/\//g, ".");
};

// Получить название Hijri месяца
const getHijriMonthName = (hijriMonth) => {
    const HIJRI_MONTHS = [
        LMTVars.muharram_title,
        LMTVars.safar_title,
        LMTVars.rabiul_awwal_title,
        LMTVars.rabiul_akheer_title,
        LMTVars.jumadal_ula_title,
        LMTVars.jumadal_akheerah_title,
        LMTVars.rajab_title,
        LMTVars.shaaban_title,
        LMTVars.ramadan_title,
        LMTVars.shawwal_title,
        LMTVars.dhul_qaadah_title,
        LMTVars.dhul_hijjah_title,
    ];
    return HIJRI_MONTHS[hijriMonth.number - 1];
};

// Универсальный fetch с обработкой ошибок
async function fetchJson(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Error fetching ${url}: ${res.status}`);
    return await res.json();
}

// Получение данных о календаре
async function getCalendarData(year, month) {
    try {
        const url = getCalendarUrl(year, month);
        return await fetchJson(url);
    } catch (error) {
        console.error(error);
        return null;
    }
}

// Создание ссылки для API
function getTodayUrl(d) {
    return `https://api.aladhan.com/v1/timings/${d}${apiParams}`;
}
function getCalendarUrl(y, m) {
    return `https://api.aladhan.com/v1/calendar/${y}/${m}${apiParams}`;
}

// Обработка CSV
function downloadCsv(content, filename) {
    const bom = "\uFEFF"; // BOM для UTF-8
    const blob = new Blob([bom + content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

function createCsvContent(header, rows) {
    return [header.join(","), ...rows].join("\n");
}

// Время в заданной временной зоне
function getNowInTimezone(tz) {
    // Время для теста — 20:00
    // const date = new Date();
    // date.setHours(20, 0, 0, 0);
    // return date;

    const now = new Date();
    return new Date(now.toLocaleString("en-US", { timeZone: tz }));
}

// Проверка, сегодня пятница
function isTodayFriday() {
    return new Date().getDay() === 5; // 0=Sun ... 5=Friday
}

// Проверка, является ли день Рамаданом
function isRamadan(day) {
    return day.date.hijri.month.number === 9;
}

// Получение текущего дня в календаре
function getTodayEntry(monthData) {
    return monthData.find(
        (d) => d.date.gregorian.date === todayISO.split("-").reverse().join("-"),
    );
}

// Обновление состояния календаря
function setCalendarState(nextState, data) {
    if (calendarState === nextState) return;
    calendarState = nextState;
    switch (nextState) {
        case CALENDAR_STATE.RAMADAN:
            activateRamadanMode(data);
            break;
        case CALENDAR_STATE.NORMAL:
            restoreNormalCalendar();
            break;
    }
}

// Форматирование даты
const date = FAKE_TODAY_ISO ? new Date(FAKE_TODAY_ISO) : new Date(),
    todayISO = formatDateISO(date),
    today = todayISO.split("-").reverse().join("-"),
    itDate = date.toLocaleDateString("it-IT", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
let currentYear = date.getFullYear();
let currentMonth = date.getMonth() + 1;

// Удаление лишнего во времени
const cleanTime = (t) => t.replace(/\s*\(.*?\)/, "");

// сделать с заглавной
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

/* ==================== UI ==================== */
const monthsWrap = document.getElementById("lmt-monthsWrap");
const todayBoxes = document.getElementById("lmt-ptBoxes");
const todayContainer = document.getElementById("lmt-ptToday");
const timer = document.getElementById("lmt-timer");

let prayerTimes = [];
let RAMADAN_MODE = false;

const jumah_t = LMTVars.jumah_title,
    jumah_time = LMTVars.jumah_time;
const jumahNote = document.createElement("p");
jumahNote.className = "lmt__jumah__note";
jumahNote.innerHTML = `<span class="lmt__jumah__mark">*</span><span class="lmt__jumah__time">Venerdì – ${jumah_t}: ${jumah_time}</span>`;

/* ================= BOXES ================= */
function createBoxes(data) {
    if (!data) return;

    // Обновляем дату Hijri
    const todayHijriDiv = document.getElementById("lmt-today-hijri");
    const hijriDate = data.date.hijri;
    const monthName = getHijriMonthName(hijriDate.month);
    if (todayHijriDiv) {
        todayHijriDiv.innerHTML = `${hijriDate.day} ${monthName} ${hijriDate.year}`;
    }

    // Создаём ячейки
    const boxes = document.getElementById("lmt-ptBoxes");
    if (!boxes) return;

    // Можно вставить сюда SVG иконки или оставить как есть
    let icon =
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="svg" width="48" height="48" viewBox="0, 0, 400,400"><g id="svgg"><path id="path0" d="M80.466 83.206 L 34.766 128.911 34.766 193.750 L 34.766 258.589 80.466 304.294 L 126.167 350.000 177.146 350.000 L 228.125 350.000 228.125 353.554 C 228.125 357.471,229.716 361.263,231.676 362.015 C 232.371 362.282,259.441 362.500,291.830 362.500 L 350.720 362.500 352.313 360.790 C 353.879 359.110,353.906 358.291,353.906 313.505 L 353.906 267.930 356.666 262.450 C 369.602 236.761,367.630 212.220,351.156 193.897 L 347.656 190.005 347.656 159.263 L 347.656 128.521 302.151 83.010 L 256.646 37.500 191.406 37.500 L 126.167 37.500 80.466 83.206 M292.398 92.008 L 334.400 134.015 334.192 155.677 L 333.984 177.340 328.125 172.589 C 315.495 162.348,306.261 151.734,299.899 140.141 C 294.173 129.710,289.506 129.787,283.366 140.417 C 275.457 154.108,269.535 160.691,251.818 175.493 C 217.360 204.279,209.909 228.642,225.873 260.329 L 228.125 264.799 228.125 301.150 L 228.125 337.500 180.276 337.500 L 132.427 337.500 90.042 295.120 L 47.656 252.740 47.656 193.755 L 47.656 134.771 90.036 92.385 L 132.416 50.000 191.406 50.000 L 250.396 50.000 292.398 92.008 M187.679 56.773 C 182.936 58.681,183.145 78.930,187.926 80.765 C 195.102 83.519,197.656 80.326,197.656 68.603 C 197.656 57.087,194.930 53.855,187.679 56.773 M94.287 95.508 C 89.893 98.749,91.442 103.839,99.041 111.133 C 105.516 117.347,107.977 117.925,111.779 114.123 C 118.396 107.506,101.868 89.917,94.287 95.508 M274.858 100.639 C 266.841 108.656,266.721 116.406,274.613 116.406 C 279.865 116.406,290.625 105.979,290.625 100.889 C 290.625 92.304,283.309 92.188,274.858 100.639 M295.754 158.594 C 301.251 166.109,309.933 174.803,322.656 185.535 C 352.100 210.370,357.400 224.547,347.117 250.977 L 345.066 256.250 291.757 256.250 L 238.447 256.250 236.493 251.367 C 225.831 224.725,231.294 210.300,261.719 184.766 C 273.795 174.631,282.054 166.272,288.013 158.157 C 290.035 155.402,291.769 153.231,291.865 153.332 C 291.961 153.433,293.711 155.801,295.754 158.594 M183.203 176.458 C 179.854 177.983,174.713 183.149,173.856 185.851 C 173.333 187.498,173.285 187.500,136.723 187.500 L 100.113 187.500 98.494 189.558 C 97.604 190.691,96.875 192.577,96.875 193.750 C 96.875 194.923,97.604 196.809,98.494 197.942 L 100.113 200.000 136.723 200.000 C 173.285 200.000,173.333 200.002,173.856 201.649 C 174.575 203.915,179.494 209.235,182.131 210.598 L 184.301 211.721 184.533 232.101 L 184.766 252.481 186.958 254.366 C 189.822 256.828,193.256 256.815,195.739 254.332 L 197.656 252.415 197.656 232.103 L 197.656 211.792 200.416 210.482 C 213.711 204.174,213.204 182.630,199.616 176.457 C 195.433 174.556,187.377 174.557,183.203 176.458 M56.157 188.286 C 52.615 190.356,52.710 197.324,56.306 199.249 C 59.398 200.904,75.566 200.166,77.313 198.290 C 79.440 196.008,79.456 191.175,77.344 189.063 C 75.620 187.338,58.832 186.724,56.157 188.286 M195.313 189.844 C 198.808 193.339,196.189 199.219,191.137 199.219 C 187.928 199.219,185.677 196.964,185.677 193.750 C 185.677 188.818,191.803 186.334,195.313 189.844 M316.016 193.057 C 310.312 196.295,311.008 200.527,318.446 207.832 C 321.717 211.044,326.268 216.176,328.560 219.237 C 337.115 230.661,348.776 224.028,340.477 212.459 C 330.227 198.170,320.542 190.488,316.016 193.057 M340.625 309.375 L 340.625 350.000 328.516 350.000 L 316.406 350.000 316.406 326.563 C 316.406 296.634,319.516 300.000,291.861 300.000 C 262.796 300.000,265.625 297.014,265.625 327.696 L 265.625 350.000 253.516 350.000 L 241.406 350.000 241.406 309.375 L 241.406 268.750 291.016 268.750 L 340.625 268.750 340.625 309.375 M99.041 276.367 C 92.744 282.411,91.271 285.078,92.277 288.610 C 94.084 294.951,99.849 294.742,106.787 288.086 C 114.640 280.551,115.733 277.331,111.779 273.377 C 107.977 269.575,105.516 270.153,99.041 276.367 M187.679 306.773 C 182.936 308.681,183.145 328.930,187.926 330.765 C 195.102 333.519,197.656 330.326,197.656 318.603 C 197.656 307.087,194.930 303.855,187.679 306.773 M303.125 331.250 L 303.125 350.000 291.016 350.000 L 278.906 350.000 278.906 331.250 L 278.906 312.500 291.016 312.500 L 303.125 312.500 303.125 331.250 " stroke="none" fill="" fill-rule="evenodd"></path></g></svg>';

    boxes.innerHTML = "";

    const friday = isTodayFriday();

    // Создаем ячейки для каждого времени
    prayerTimes.forEach((p) => {
        let label = p.label;
        let time = p.time;
        if (friday && p.key === "Dhuhr") {
            label = "Jumu'ah";
            time = "13:20"; // или из настроек
        }

        const box = document.createElement("div");
        box.className = "lmt__ptBox";
        box.id = `lmt-pr-${p.key}`;
        box.innerHTML = `${icon} <h3 class="lmt__pr__title">${label}</h3> <div class="lmt__pr__time">${time}</div>`;
        boxes.appendChild(box);
    });

    startTimer(); // запуск таймера
}

/* ================= TABLE CREATION ================= */
/* ====== TODAY TABLE ====== */
function createTodayTable(data) {
    // Создаем таблицу
    const getTodayDate = data.date;
    const todayHijriDate = getTodayDate.hijri;

    const weekday = capitalize(
        new Intl.DateTimeFormat("it-IT", { weekday: "long" }).format(
            parseGregorian(getTodayDate.gregorian.date),
        ),
    );

    let tableWrapper = document.createElement("div");
    let titles = document.createElement("div");
    let todayTable = document.createElement("table");
    let tableBody = document.createElement("tbody");

    tableWrapper.className = "lmt__pt__box";
    titles.className = "lmt__pt__titles";
    todayTable.className = "lmt__pt__table lmt__pt__table_today";
    tableBody.className = "lmt__pt__times";

    // Заполняем
    todayContainer.appendChild(tableWrapper);
    tableWrapper.appendChild(titles);
    tableWrapper.appendChild(todayTable);
    todayTable.appendChild(tableBody);

    // Заголовки
    const monthName = getHijriMonthName(todayHijriDate.month);
    let displayTitles = `<h5>${itDate}</h5> <h5>${todayHijriDate.day} ${monthName}, ${todayHijriDate.year}</h5> <div>(${weekday} - <span class="ar-w">${todayHijriDate.weekday.ar}</span>)</div>`;
    titles.innerHTML = displayTitles;

    // Создаем строки
    const friday = isTodayFriday();

    prayerTimes.forEach((p) => {
        let label = p.label;
        let time = p.time;
        if (friday && p.key === "Dhuhr") {
            label = "Jumu'ah";
            time = "13:20";
        }
        const tr = document.createElement("tr");
        tr.className = "lmt__pt__time";
        tr.innerHTML = `<td>${label}</td> <td>${time}</td>`;
        tableBody.appendChild(tr);
    });
    return tableBody;
}

/* ====== CALENDAR TABLE ====== */
// Создаем таблицу
if (typeof monthsWrap !== "undefined" && monthsWrap !== null) {
    const container = document.createElement("div");
    container.id = "tableContainer";
    container.className = "lmt__table__container";
    monthsWrap.append(container, jumahNote);
}
function createPrayerTable(mode = "normal") {
    const isRamadanMode = mode === "ramadan";
    const container = document.getElementById("tableContainer");

    if (!container) return;

    container.innerHTML = "";

    const table = document.createElement("table");
    table.id = isRamadanMode ? "ramadanTable" : "monthTable";
    table.className = `lmt__pt__table lmt__pt__table_month ${isRamadanMode ? "lmt__pt__table_ramadan" : ""}`;

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    headerRow.innerHTML = `
    <th colspan="2" id="${isRamadanMode ? "ramadanTitle" : "monthTitle"}"></th>
    <th id="${isRamadanMode ? "ramadanColumnTitle" : "defaultColumnTitle"}"></th>
    ${isRamadanMode ? `<th>${LMTVars.imsak_title}</th>` : ""} <!-- колонка только в режиме Ramadan -->
    ${CONFIG.prayers.map((p) => `<th>${p.label}</th>`).join("")}
  `;
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    tbody.id = isRamadanMode ? "ramadanBody" : "monthBody";
    table.appendChild(tbody);

    container.appendChild(table);

    updateTableTitle(mode);
}

/* ====== CALENDAR TABLE TITLE UPDATE ====== */
function updateTableTitle(mode = "normal", ramadanDays = []) {
    const isRamadanMode = mode === "ramadan";

    const monthTitleEl = document.getElementById(
        isRamadanMode ? "ramadanTitle" : "monthTitle",
    );
    const columnTitleEl = document.getElementById(
        isRamadanMode ? "ramadanColumnTitle" : "defaultColumnTitle",
    );
    if (!monthTitleEl || !columnTitleEl) return;

    if (isRamadanMode) {
        const hijriYear = ramadanDays.length
            ? ramadanDays[0].date.hijri.year
            : new Date().getFullYear();
        monthTitleEl.textContent = `Ramadan ${hijriYear}`;
        columnTitleEl.textContent = "Dati";
    } else {
        monthTitleEl.textContent = capitalize(
            new Date(currentYear, currentMonth - 1, 1).toLocaleDateString("it-IT", {
                month: "long",
                year: "numeric",
            }),
        );
        columnTitleEl.textContent = "Hijri";
    }
}

/* ====== CALENDAR TABLE BODY ====== */
function renderPrayerTableBody(days, mode = "normal") {
    const isRamadanMode = mode === "ramadan";
    const tbodyId = isRamadanMode ? "ramadanBody" : "monthBody";
    const tbody = document.getElementById(tbodyId);
    if (!tbody) return;

    if (!days || days.length === 0) {
        tbody.innerHTML = `<tr><td colspan="${CONFIG.prayers.length + (isRamadanMode ? 4 : 3)}">No data found</td></tr>`;
        return;
    }

    let html = "";

    days.forEach((day) => {
        const g = day.date.gregorian;
        const hijri = day.date.hijri;
        const weekday = capitalize(
            new Intl.DateTimeFormat("it-IT", { weekday: "long" }).format(
                parseGregorian(g.date),
            ),
        );
        const gregDate = g.date.replace(/-/g, ".");
        const hijriFullDate = `${hijri.day} ${getHijriMonthName(hijri.month)} ${hijri.year}`;

        const hijriDay = hijri.day; // число

        const isFriday = weekday.toLowerCase() === "venerdì";

        // Колонка Imsak — только если режим Ramadan
        const imsakCell = isRamadanMode
            ? `<td class="lmt__imsak">${cleanTime(day.timings.Imsak || "")}</td>`
            : "";

        // Создаем ячейки с молитвами
        const prayerCells = CONFIG.prayers
            .map((p) => {
                let time = cleanTime(day.timings[p.key]);
                const classes = [];

                if (isFriday && p.key === "Dhuhr") {
                    classes.push("lmt__jumah");
                    time += '<span class="lmt__jumah__mark">*</span>';
                }

                const classAttr = classes.length ? `class="${classes.join(" ")}"` : "";
                return `<td ${classAttr}>${time}</td>`;
            })
            .join("");

        // Строка
        html += `<tr class="${g.date === today ? "lmt__pt__current" : ""} ${hijri.day === "1" && g.date != today ? "lmt__hijri-new-month" : ""}">
      ${isRamadanMode ? `<td>${hijriDay}</td><td>${weekday}</td><td>${gregDate}</td>` : `<td>${g.day}</td><td>${weekday}</td><td>${hijriFullDate}</td>`}
      ${imsakCell}
      ${prayerCells}
    </tr>`;
    });

    tbody.innerHTML = html;
}

/* ================= DATA ================= */
// Загрузка данных на сегодня
async function loadTodayData() {
    try {
        const json = await fetchJson(getTodayUrl(today));
        const timings = json.data.timings;
        prayerTimes = CONFIG.prayers.map((p) => ({
            key: p.key,
            label: p.label,
            time: timings[p.key],
        }));

        if (typeof todayBoxes !== "undefined" && todayBoxes !== null) {
            createBoxes(json.data);
        }

        if (typeof todayContainer !== "undefined" && todayContainer !== null) {
            createTodayTable(json.data);
        }
    } catch (error) {
        console.warn("Error loading today data:", error);
    }
}

// Загрузка календаря
async function loadCalendar() {
    if (RAMADAN_MODE) return;

    const data = await getCalendarData(currentYear, currentMonth);
    if (!data) return;

    const todayEntry = getTodayEntry(data.data);
    if (todayEntry && isRamadan(todayEntry)) {
        await activateRamadanMode(data.data);
        return;
    }
    setCalendarState(CALENDAR_STATE.NORMAL);
    createPrayerTable("normal");
    renderPrayerTableBody(data.data, "normal");
    updateTableTitle("normal");
}

// Восстановление нормального календаря
function restoreNormalCalendar() {
    monthsWrap.style.opacity = 0;
    setTimeout(() => {
        monthsWrap.innerHTML = "";
        createPrayerTable("normal");
        loadCalendar();
        monthsWrap.style.opacity = 1;
    }, 300);
}

// Переключение месяца
function changeMonth(delta) {
    currentMonth += delta;
    if (currentMonth < 1) {
        currentMonth = 12;
        currentYear--;
    } else if (currentMonth > 12) {
        currentMonth = 1;
        currentYear++;
    }
    document.getElementById("monthSelect").value = currentMonth;
    document.getElementById("yearSelect").value = currentYear;
    loadCalendar();
    updateNavButtons();
}

// Активация режима Рамадан
async function activateRamadanMode(days) {
    monthsWrap.style.opacity = 0;
    await new Promise((r) => setTimeout(r, 300));
    document.querySelector(".lmt__pt__controls")?.remove();

    let ramadanDays = days.filter(isRamadan);
    const lastDay = days[days.length - 1];

    if (lastDay && isRamadan(lastDay)) {
        let nextMonth = currentMonth + 1;
        let nextYear = currentYear;
        if (nextMonth > 12) {
            nextMonth = 1;
            nextYear++;
        }
        const nextData = await getCalendarData(nextYear, nextMonth);
        if (nextData) {
            ramadanDays = ramadanDays.concat(nextData.data.filter(isRamadan));
        }
    }

    createPrayerTable("ramadan");
    renderPrayerTableBody(ramadanDays, "ramadan");
    updateTableTitle("ramadan", ramadanDays);
    monthsWrap.style.opacity = 1;
}

/* ================= TIMER ================= */
let todayPrayerDates = [];
let lastBuiltDay = null;
let prayerSwitchTimeout = null;
let countdownInterval = null;
function buildTodayPrayerDates() {
    const now = getNowInTimezone(CONFIG.location.timezone);
    const todayKey = now.toDateString();
    if (todayKey === lastBuiltDay) return;
    lastBuiltDay = todayKey;
    todayPrayerDates = prayerTimes.map((p) => {
        const [h, m] = cleanTime(p.time).split(":").map(Number);
        const d = new Date(now);
        d.setHours(h, m, 0, 0);
        return { ...p, date: d };
    });
}
function getNextPrayerDate(now) {
    if (!todayPrayerDates.length) return null;
    const next = todayPrayerDates.find((p) => p.date > now);
    if (!next) {
        const fajr = todayPrayerDates.find((p) => p.key === "Fajr");
        const tomorrow = new Date(fajr.date);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return { name: `Fajr (${CONFIG.i18n.tomorrow})`, date: tomorrow };
    }
    return { name: next.key, date: next.date };
}
function startTimer() {
    if (countdownInterval) return;
    buildTodayPrayerDates();
    scheduleNextPrayerSwitch();
    updatePrayerTimer();

    // immediate render
    countdownInterval = setInterval(updateCountdownOnly, 1000);
}
function scheduleNextPrayerSwitch() {
    if (!todayPrayerDates.length) return null;
    if (prayerSwitchTimeout) {
        clearTimeout(prayerSwitchTimeout);
    }
    const now = getNowInTimezone(CONFIG.location.timezone);
    const next = todayPrayerDates.find((p) => p.date > now);
    let targetDate;
    if (!next) {
        // Tomorrow Fajr
        const fajr = todayPrayerDates.find((p) => p.key === "Fajr");
        targetDate = new Date(fajr.date);
        targetDate.setDate(targetDate.getDate() + 1);
    } else {
        targetDate = next.date;
    }
    const delay = Math.max(0, targetDate - now);
    prayerSwitchTimeout = setTimeout(() => {
        buildTodayPrayerDates();
        updatePrayerTimer();

        // 🔥 instant UI update
        scheduleNextPrayerSwitch();

        // schedule next switch
    }, delay);
}

function updateCountdownOnly() {
    const now = getNowInTimezone(CONFIG.location.timezone);
    const next = getNextPrayerDate(now);
    if (!next) return;
    updateTimer(next.name, next.date);
}
function updatePrayerTimer() {
    const now = getNowInTimezone(CONFIG.location.timezone);
    const currentEl = document.querySelector(".lmt__ptBox_current");
    currentEl?.classList.remove("lmt__ptBox_current");
    const next = todayPrayerDates.find((p) => p.date > now);
    if (!next) {
        highlight("Isha");
        return;
    }
    if (next.key === "Dhuhr") {
        return;
    }
    const idx = todayPrayerDates.indexOf(next);
    const current = todayPrayerDates[idx - 1];
    if (current && current.key !== "Sunrise") {
        highlight(current.key);
    }
    updateTimer(next.key, next.date);
}
function highlight(key) {
    if (!key || key === "Sunrise") return;
    document.getElementById(`lmt-pr-${key}`)?.classList.add("lmt__ptBox_current");
}
function updateTimer(name, date) {
    const now = getNowInTimezone(CONFIG.location.timezone);
    const diff = Math.max(0, date - now);
    const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
    timer.textContent = `${name} tra ${h}:${m}:${s}`;
}

// ==================== init ====================
loadTodayData();

if (typeof monthsWrap !== "undefined" && monthsWrap !== null) {
    createPrayerTable("normal");
    loadCalendar();
}
